import { Fields } from "../../types/SchemaFactory";
import { TFunction } from "i18next";
import { schemaFactory } from "../SchemaFactory";
import {
    UserRegistrationFirstStep,
    UserRegistrationSecondStep,
} from "../../domain/models/dto/UserDTO";

export const userRegistrationFirstStepFields: Fields<UserRegistrationFirstStep> =
    {
        email: {
            min: 1,
            max: 128,
            required: {
                value: true,
                key: "registration.emailRequired",
            },
            placeholderKey: "registration.emailField",
            type: "email",
            initial: "",
        },
        password: {
            min: 8,
            max: 128,
            required: {
                value: true,
                key: "registration.passwordRequired",
            },
            placeholderKey: "registration.passwordField",
            type: "password",
            initial: "",
        },
        confirmPassword: {
            min: 0,
            max: 128,
            required: {
                value: true,
                key: "registration.confirmPasswordRequired",
            },
            placeholderKey: "registration.confirmPasswordField",
            type: "text",
            initial: "",
        },
    };

export const userRegistrationSecondStepFields: Fields<UserRegistrationSecondStep> =
    {
        firstName: {
            min: 2,
            max: 30,
            required: {
                value: true,
                key: "registration.firstNameRequired",
            },
            placeholderKey: "registration.firstNameField",
            type: "text",
            initial: "",
        },
        lastName: {
            min: 2,
            max: 30,
            required: {
                value: true,
                key: "registration.lastNameRequired",
            },
            placeholderKey: "registration.lastNameField",
            type: "text",
            initial: "",
        },
    };

export const userRegistrationFirstStepSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, userRegistrationFirstStepFields);
};

export const userRegistrationSecondStepSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, userRegistrationSecondStepFields);
};
